<template>
  <div class="card border-0 shadow-none rounded-1 mb-30">
    <div class="card-body p-xl-40">
      <h6 class="fs-18 mb-35 text-title fw-semibold">
        {{ $t("sales_page.selected_products_for_sales") }}
      </h6>
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-title fw-normal fs-14 pt-0 ps-0 ls-1">
                {{ $t("sales_page.product") }}
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0 ls-1">
                {{ $t("sales_page.code") }}
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0 ls-1">
                {{ $t("sales_page.unit_price") }}
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0 ls-1">
                {{ $t("sales_page.stock") }}
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0 ls-1">
                {{ $t("sales_page.quantity") }}
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0 ls-1">
                {{ $t("sales_page.discount") }}
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0 ls-1">
                {{ $t("sales_page.tax") }}
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0 ls-1">
                {{ $t("sales_page.subtotal") }}
              </th>
              <th
                scope="col"
                class="text-title fw-normal fs-14 pt-0 ls-1 text-end pe-0"
              >
                {{ $t("sales_page.delete") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="product in products" :key="product.id">
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph ps-0">
                {{ product.product }}
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                {{ product.code }}
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                $ {{ product.cost }}
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                <span class="badge badge-success fw-semibold fs-14">
                  {{ product.stock }}
                </span>
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                <QuantityCounter 
                  :model-value="product.qty"
                  @update:modelValue="(q) => updateQty(product.id, q)"
                />
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                <div class="input-group input-group-sm" style="width: 120px;">
                  <input 
                    type="number" 
                    class="form-control form-control-sm border-end-0" 
                    :value="product.discount"
                    @input="(e) => updateDiscount(product.id, Number((e.target as HTMLInputElement).value), product.discount_type as 'fixed' | 'percentage')"
                  />
                  <select 
                    class="form-select form-select-sm bg-light" 
                    style="max-width: 50px; padding-left: 5px; padding-right: 5px;"
                    :value="product.discount_type"
                    @change="(e) => updateDiscount(product.id, product.discount, (e.target as HTMLSelectElement).value as 'fixed' | 'percentage')"
                  >
                    <option value="fixed">$</option>
                    <option value="percentage">%</option>
                  </select>
                </div>
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                $ {{ product.tax }}
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                $ {{ product.subTotal.toFixed(2) }}
              </td>
              <td class="shadow-none lh-1 text-end pe-0">
                <div
                  class="button-group style-two ms-auto d-flex flex-wrap align-items-center"
                >
                  <a
                    class="delete-btn"
                    href="javascript:void(0)"
                    role="button"
                    @click.prevent="removeProduct(product.id)"
                  >
                    <img
                      src="../../../assets/img/icons/close.svg"
                      alt="Image"
                    />
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import QuantityCounter from "./QuantityCounter.vue";
import stateStore from "../../../utils/store";

export default defineComponent({
  name: "SelectedProducts",
  components: {
    QuantityCounter,
  },
  setup() {
    const products = computed(() => stateStore.selectedProducts.map(p => {
      const discountAmount = p.discount_type === 'percentage' 
        ? (p.price * p.qty * p.discount) / 100 
        : p.discount;
      
      return {
        id: p.id,
        product: p.name,
        code: p.code,
        stock: p.stock,
        cost: p.price,
        qty: p.qty,
        discount: p.discount,
        discount_type: p.discount_type,
        tax: 0,
        subTotal: (p.price * p.qty) - discountAmount
      };
    }));

    const removeProduct = (id: number) => {
      stateStore.removeSelectedProduct(id);
    };

    const updateQty = (id: number, qty: number) => {
      stateStore.setProductQty(id, qty);
    };

    const updateDiscount = (id: number, discount: number, type: 'fixed' | 'percentage') => {
      stateStore.setProductDiscount(id, discount, type);
    };

    return {
      products,
      removeProduct,
      updateQty,
      updateDiscount,
      stateStore
    };
  }
});
</script>
